module.exports = __webpack_public_path__ + "img/4-4.c883e0e8.svg";